function toogleMenu() {
  const isMenuOpened = $('.tmenu_app').hasClass('showed');

  if (isMenuOpened) {
    hideMenu()
  } else {
    $('.tmenu_app').addClass('showed');
    $('.tmenu_app').slideDown(300)
  }
}

function hideMenu() {
  $('.tmenu_app').removeClass('showed');
  $('.tmenu_app').slideUp(300)
}


$('.mobile-navigation-trigger').click(function (e) {

  e.stopPropagation();
  toogleMenu()

})

$('html, body').click(function () {
  if ($(window).width() <= 767) {
    hideMenu()
  }
});

let icons = $('.header-icons').clone();

setTimeout(() => {
  $('.tr-main-nav').append(icons);
}, 500)